<template>
  <div>
    <div
      @click="$emit('show-PopupDetail2', order.id, order.integrationOrderId)"
      slot="header"
    >
      <div
        v-if="order.orderStatus != -1 && order.orderStatus != 3"
        style="
          display: flex;
          justify-content: flex-end;
          align-items: flex-start;
          margin-bottom: 4px;
        "
      >
        <button
          @click.stop="
            $emit('show-popup', order.id, order.integrationOrderId, -1)
          "
          style="
            background: transparent;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #e53935;
            padding: 0 8px;
          "
          aria-label="Cancel"
        >
          &times;
        </button>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
        "
      >
        <div
          style="
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: #f2f2f2;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            overflow: hidden;
          "
        >
          <img
            v-if="order.logo"
            :src="order.logo"
            alt="Logo"
            style="
              width: 48px;
              height: 48px;
              object-fit: contain;
              border-radius: 50%;
            "
          />
          <span v-else style="font-size: 24px; color: #bbb">?</span>
        </div>
      </div>
      <vs-row vs-align="flex-start">
        <vs-col vs-justify="center" vs-align="center" vs-w="6">
          Teslimat
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          v-if="order.orderStatus != -1 && order.orderStatus != 3"
        >
          Kalan Süre
        </vs-col>
      </vs-row>
      <vs-row vs-align="flex-start">
        <vs-col vs-w="6">
          <h3>{{ order.deliveryDateString }}</h3>
        </vs-col>
        <vs-col
          vs-w="6"
          v-if="order.orderStatus != -1 && order.orderStatus != 3"
        >
          <h3>
            <div :class="{ warning: order.tableId <= 120 }">
              {{ remainingTime }}
            </div>
          </h3>
        </vs-col>
      </vs-row>
    </div>
    <div>
      <vs-row vs-align="flex-end">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button
            size="large"
            full-width
            title="Siparişi görüntüle"
            type="gradient"
            color="primary"
            icon-pack="feather"
            icon="icon-eye"
            @click="
              $emit('show-PopupDetail2', order.id, order.integrationOrderId)
            "
            ><div full-width></div
          ></vs-button>
        </vs-col>
        <vs-col
          v-if="order.orderStatus != -1 && order.orderStatus != 3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button
            size="large"
            full-width
            title="this.nextTitle"
            type="gradient"
            color="success"
            icon-pack="feather"
            icon="icon-chevrons-right"
            @click="
              $emit(
                'show-popup',
                order.id,
                order.integrationOrderId,
                nextStatus
              )
            "
            ><div full-width></div
          ></vs-button>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    nextTitle: {
      type: String,
      required: false,
    },
    nextStatus: {
      type: Number,
      required: false,
    },
    remainingTime: {
      type: String,
      required: true,
    },
  },
};
</script>
